import { FC, useEffect, useMemo } from 'react';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { ILocation } from 'types/common';
import { mapBoxTranslations } from './translations';
import { IMapBoxProps, MapBoxTransFields } from './types';
import styles from './map.module.scss';

const RecenterMap: FC<{ location: ILocation }> = ({ location: { lat, lng } }) => {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng]);
  }, [lat, lng]);
  return null;
};

export const MapBox: FC<IMapBoxProps> = ({ locations, onDragEnds, draggableMarkers = true, classNameProp }) => {
  const { t } = useMyTranslations<MapBoxTransFields>([mapBoxTranslations.name]);

  const onDragEndsHadler = (location: ILocation) => {
    onDragEnds && onDragEnds(location);
  };

  const { lat, lng } = useMemo(() => locations[0], [locations]);

  return (
    <div className={`${styles.content} ${classNameProp}`}>
      <h6 className={`${styles.title}`}>{t('map')}</h6>
      <div className={styles.mapBox} id='map'>
        {
          <MapContainer center={[lat, lng]} zoom={18} className={styles.mapContainer}>
            <RecenterMap location={{ lat, lng }} />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            />
            {locations.map((item) => (
              <Marker
                key={`${item.lat}+${item.lng}`}
                position={[item.lat, item.lng]}
                draggable={draggableMarkers}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                eventHandlers={{ dragend: (e: any) => onDragEndsHadler(e.target['_latlng']) }}
              />
            ))}
          </MapContainer>
        }
      </div>
    </div>
  );
};
